<template>
  <div :class="'repeater-row-'+propertyIndex" class="row repeater-row-lg">
    <div class="form-group col-lg">
      <m-autocomplete
              :items="getProductPropertiesAutocomplete"
              :label="$t('products.properties.name')"
              :labelClass="'m-show-lg'"
              v-model="property.name"
              v-if="renderedComponent"
      />
    </div>
    <div class="form-group col-lg">
      <label class="m-show-lg" :for="'propertyValue-'+propertyIndex">{{ $t('products.properties.value') }}</label>
      <input class="form-control"
             :id="'propertyValue-'+propertyIndex"
             type="text"
             v-model.trim="property.propertyValue"
      >
    </div>
    <div class="col repeater-actions-lg repeater-last-lg">
      <add-remove-row
              @click.native="$emit('addPropertyRow')"
              v-if="propertyIndex === (properties.length-1)"
      />
      <add-remove-row
              @click.native="removedRow(propertyIndex)"
              v-else
              :iconClass="'minus'"
      />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import addRemoveRow from '../general/addRemoveRow'
  import {renderComponent} from '../../mixins/renderComponent'

  //@vuese
  // @group Products
  export default {
    name: 'PropertyRow',
    components: {
      addRemoveRow
    },
    inject: ['$validator'],
    props: {
      properties: Array,
      property: Object,
      propertyIndex: Number
    },
    mixins: [renderComponent],
    computed: {
      ...mapGetters('products', [
        'getProductPropertiesAutocomplete'
      ])
    },
    methods: {
      //@vueuse
      removedRow(propertyIndex) {
        this.$emit('propertyRemoved', propertyIndex);
        this.renderComponent()
      }
    }
  }
</script>